<template>
	<div class="loginbg" :style="{backgroundImage:'url(./images/xjxxlogin.jpg)'}">

		<!-- <div class="loginbg" style="position: absolute; opacity: 0; top: 0; z-index: 999;" :style="{backgroundImage:'url(./images/canzhao.png)'}">
		</div> -->
		<!-- :style="{backgroundImage:'url('+bgidx+')'}" -->
		<!-- 	<div  style="position: absolute; top: 10%; width: 25%; left: 6%;">
			<img :src="'./images/logo_login.png'"  style="width: 100%;"/>
		</div> -->
		<div class="login_box">
			<div
				style="text-align: center; padding-bottom: 20px; color: #00A0E9; font-size: 24px; font-weight: bold; margin-bottom: 20px;">
				<img v-if="config" :src="config.logo2" style="width: 300px;" />
			</div>

			<div v-if="!showQrcode">


				<el-form :model="EditItem">

					<el-form-item>

						<el-input style="height: 50px;" size="large" placeholder="请输入账号" @keyup.enter.native="login"
							v-model="username">
							<template slot="prepend">手 机 号 码</template>
						</el-input>

					</el-form-item>
					<el-form-item>

						<div style="width: 60%; float: left;">
							<el-input style="height: 50px;" type="text" placeholder="请输入短信验证码"
								@keyup.enter.native="login" v-model="password">

							</el-input>
						</div>
						<div style="margin-left: 60%; height: 50px; overflow: hidden;" @click="reSendSms">
							<el-button style="width: 150px; margin-left: 18px; height: 50px; ">{{smsStatus}}</el-button>

						</div>


					</el-form-item>
					<el-form-item>

						<div style="width: 60%; float: left;">
							<el-input style="height: 50px;" type="text" placeholder="请输入验证码" @keyup.enter.native="login"
								v-model="yzm">

							</el-input>
						</div>
						<div style="margin-left: 60%; height: 40px; overflow: hidden;" @click="changeYzm">
							<div style="border: 0; width: 150px; height: 50px; transform: scale(0.8,0.8); transform-origin: left top;"
								v-html="yzmUrl">
							</div>

						</div>


					</el-form-item>

					<div style="height: 20px; text-align: center; padding-top: 50px;">
						<el-button type="primary" style="width: 100%; height: 50px;" @click="login">登录</el-button>
					</div>
				</el-form>

			</div>

			<div v-else>
				<div style="width: 60%; margin: 0 auto; padding-top: 30px;">
					<img :src="qrcodeUrl?qrcodeUrl:'../../images/qrcode.jpg'" alt="" style="width: 100%;">
				</div>

			</div>



		</div>



	</div>
</template>

<script>
	export default {
		data() {
			return {
				isShowModal: false,
				showbtn: false,
				bgidx: "",
				bgvideourl: "",
				EditItem: {},
				username: "",
				password: "",
				session_id: "",
				yzmUrl: "",
				yzm: "",
				showQrcode: false,
				qrcodeUrl: "",
				qrcodeChecking: false,
				qrcodeTimer: -1,
				pwdForm: {
					newPwd1: "",
					newPwd2: "",

				},
				smsStatus: "发送验证码",
				second: 120,
				smsforce: 0,
				smsTimer: 0,
				config: null
			}
		},
		mounted() {

			this.getSchool()
			this.getYZM()

		},
		methods: {

			getSchool() {
				this.$http.post("/api/platform_settings", {
					pmid: window.pmid
				}).then(res => {
					let config = {
						logo: "",
						leftlogo: "",
						logo2: "",
						mainbg: "",
						schoolname: "",
						loginbg: "",
						favico: ""
					}
					for (let k of res.data) {

						switch (k.ktype) {
							case 'logo':
								config.logo = k.kvalue
								break;
							case 'leftlogo':
								config.leftlogo = k.kvalue
								break;
							case 'logo2':
								config.logo2 = k.kvalue
								break;
							case 'mainbg':
								config.mainbg = k.kvalue
								break;
							case 'schoolname':
								config.schoolname = k.kvalue
								document.title="欢迎登陆"+config.schoolname+"招生平台"
								break;
							case 'loginbg':
								config.loginbg = k.kvalue
								break;
							case 'favico':
								config.favico = k.kvalue
								break;
						}

					}
					if (config.favico) {
						var link = document.createElement('link');
						link.type = 'image/x-icon';
						link.rel = 'shortcut icon';
						link.href = config.favico;
						document.getElementsByTagName('head')[0].appendChild(link);
					}
					this.config = config




				})


			},
			reSendSms() {
				if (!(/^1\d{10}$/.test(this.username))) {
					this.$message.error("手机号码格式错误！请输入11位手机号码！");
					return false;
				}
				if (this.second == 120) {
					clearInterval(this.smsTimer)
					this.second = 120;
					this.smsStatus = this.second + "S后重发"
					this.smsforce = true
					this.smsTimer = setInterval(() => {
						this.second--;
						this.smsStatus = this.second + "S后重发"
						if (this.second == 0) {
							clearInterval(this.smsTimer)
							this.second = 120;
							this.smsStatus = "发送验证码"
						}
					}, 1000)
					this.$http.post("/api/student_smsyzm", {
						phone: this.username,
						force: this.smsforce
					}).then(res => {

						this.$message.success("验证码已发送，请注意查收！")
					})
				}




			},

			getYZM() {
				this.$http.post("/api/get_login_randomcode", {
					pmid: window.pmid
				}).then(res => {
					this.session_id = res.data.data.session_id;
					this.yzmUrl = res.data.data.svg;
				})
			},
			changeYzm() {
				this.getYZM()
			},
			login() {




				if (this.username.trim() && this.password.trim() && this.yzm.trim()) {
					this.$http.post("/api/stu_bklogin", {
						phone: this.username,
						smsyzm: this.password,
						yzm: this.yzm.toLowerCase(),
						session_id: this.session_id,
						pmid: window.pmid
					}).then(res => {

						if (res.data.code == 200) {
							sessionStorage.setItem("phone", res.data.phone)
							sessionStorage.setItem("year", res.data.year)
							this.$router.push("/pcbk")
						}



					}, err => {

					})
				} else {
					this.$message({
						message: "好像没有填完整~",
						type: 'error',
						offset: '100'
					});
				}
			},
			changeLoginType() {
				this.showQrcode = !this.showQrcode
				if (this.showQrcode && !this.qrcodeUrl) {
					this.getQrcode()
				}
			},

			checkPassWord(value) {
				if (value.length < 8 || value.length > 16) { //最初级别
					this.$message.error("密码长度为8-16位")
					return false;
				}
				if (!/\d/.test(value)) { //如果用户输入的密码 包含了数字
					this.$message.error("密码必须包含数字")
					return false;
				}
				if (!/[a-z]/.test(value) && !/[A-Z]/.test(value)) { //如果用户输入的密码 包含了小写的a到z
					this.$message.error("密码必须包含大小写字母")
					return false;
				}

				var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
					regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

				if (!regEn.test(value) && !regCn.test(value)) {
					this.$message.error("密码必须包含特殊字符")
					return false;
				}

				return true


			},

			savePwd() {

				if (!this.pwdForm.newPwd1) {
					this.$message.error("请输入新密码")
					return
				}
				if (!this.pwdForm.newPwd2) {
					this.$message.error("请再次输入新密码")
					return
				}
				if (this.pwdForm.newPwd1 != this.pwdForm.newPwd2) {
					this.$message.error("两次密码不一致")
					return
				}
				if (this.checkPassWord(this.pwdForm.newPwd2)) {
					this.showbtn = true;
					this.$http.post("/api/reset_myself_pwd_first", this.pwdForm).then(ok => {
						if (ok.data) {
							this.$message.success("修改成功,即将跳转")
							setTimeout(() => {
								this.$router.push("/home")
							}, 3000)

						}
					})
				}


			},
		}
	}
</script>

<style scoped>
	.loginbg {
		width: 100%;
		height: 100%;
		background-size: cover;
		background-position: top;
		position: relative;
	}

	.login_box {
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -240px;
		margin-top: -250px;
		border-radius: 4px;
		-moz-border-radius: 4px;
		-webkit-border-radius: 4px;
		background-color: #f5f8fe;
		width: 420px;
		height: 440px;
		padding: 30px;

	}

	.coricon {
		position: absolute;
		top: 0;
		right: 0;
		;
		width: 60px;
		height: 60px;
	}

	.coricon img {
		width: 100%;
		transform: scale(0.5, 0.5);
	}

	.bgvideo {
		position: fixed;
		width: 100%;
		height: 100%;
		top: -10;
		left: 0;
		z-index: -100;
		background-size: cover;
	}

	/deep/ .el-input__inner {
		height: 100% !important;
	}

	/deep/ .el-button--primary {
		width: 100%;
		background-color: none;
		background: linear-gradient(to right, #3492ff, #1d7bff);
	}

	/deep/ .el-button--primary:hover {
		width: 100%;
		background-color: none;
		background: linear-gradient(to right, #3492ff, #1d7bff);
	}
</style>
